<template>
    <div class="repairCardRequest">
        <el-dialog title="补卡申请" :visible.sync="sta" width="810px" :before-close="cancel">
            <div class="leaveRequest_content">
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span> 申请人：
                        </span>
                        <div style="position:relative">
                            <!-- <el-input
                                v-model="Form.partmentName"
                                @focus="departpopshow=!departpopshow"
                                placeholder="不限"
                                clearable
                            ></el-input>
                            <div class="departpop" v-show="departpopshow">
                                <el-tree
                                    :default-expand-all="true"
                                    :data="departmentList"
                                    :props="defaultProps"
                                    @node-click="handleNodeClick"
                                >
                                    <span class="custom-tree-node" slot-scope="{ node,data}">
                                        <div>
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='区'"
                                                src="../../../assets/icon/quyu.png"
                                                alt
                                            />
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='店'"
                                                src="../../../assets/icon/dian.png"
                                                alt
                                            />
                                            <img
                                                class="tree-icon"
                                                v-if="data.labelName=='组'"
                                                src="../../../assets/icon/zu.png"
                                                alt
                                            />
                                            <span>{{ data.name }}</span>
                                        </div>
                                    </span>
                                </el-tree>
                            </div> -->
                            <el-select
                                v-model="Form.employeeId"
                                placeholder="不限"
                                @visible-change="Getmessage"
                                @change="queryCheckEmployee(),queryShifts()"
                                clearable
                            >
                                <el-option
                                    v-for="(item,index) in userList"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.id"
                                ></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="item_div">
                        <span class="label">申请时间：</span>
                        {{curTime}}
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span>时间：
                        </span>
                        <el-date-picker
                            type="date"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd HH:mm"
                            v-model="Form.beginDatetime"
                            placeholder="请选择"
                            @input="queryShifts"
                        ></el-date-picker>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span>补卡班次：
                        </span>
                        <el-checkbox-group v-model="Form.repairCardTime">
                            <el-checkbox  v-for="(item,index) in shiftList" :key="index" :disabled="!item.status"  :label="item.shifts">{{item.shifts}}</el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">
                            <span class="notice">*</span>补卡详情：
                        </span>
                        <el-input v-model="Form.applyDemo" type="textarea" placeholder="请输入内容"></el-input>
                    </div>
                </div>
                <div class="item">
                    <div class="item_div">
                        <span class="label">图片：</span>
                        <el-upload
                            class="avatar-uploader"
                            :action="`${$uploadUrl}/erp/qiniu/uploadImg`"
                            :show-file-list="false"
                            :on-success="handleAvatarSuccess"
                            :on-error="handleAvatarError"
                            :headers="headers"
                            :multiple="true"
                            accept=".png, .jpg, .jpeg"
                        >
                            <img
                                v-if="Form.pictureIds"
                                :src="'http://'+Form.pictureIds"
                                class="avatar"
                            />
                            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                        <!-- <el-input v-model="input" type="textarea" placeholder="请输入内容"></el-input> -->
                    </div>
                </div>
                <div class="item">
                    <div class="item_div" v-if="checkList.length!=0">
                        <span class="label">审批人：</span>
                        <!-- <div class="item_list" v-for="(ite,index) in checkList" :key="index">
                            <div v-for="(item,index) in ite.names" :key="index">
                                <span class="person">{{item}}</span>
                                <i class="iconfont1 el-icon-minus" v-if="index!=ite.names.length-1"></i>
                            </div>
                            <i v-if="index!=checkList.length-1" class="iconfont1 el-icon-plus"></i>
                        </div>-->
                        <div class="item_list">
                            <div v-for="(item,index) in checkList" :key="index">
                                <span class="person" v-if="item!='-'&&item!='+'">{{item}}</span>
                                <i v-if="item=='-'" class="iconfont1 el-icon-minus"></i>
                                <i v-if="item=='+'" class="iconfont1 el-icon-plus"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="dialog-foot">
                <button class="foot-cancel" @click="cancel">取消</button>
                <button v-points class="foot-save" @click="save">确定</button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import VueCookies from "vue-cookies";
import {
    holidayQuery,
    addApplication,
    queryCheckEmployee,
    queryShifts
} from "@/api/checkingIn";
import { departmentFind, employeeQuery } from "@/api/manageCenter";
import { currentTime } from "@/vue/util/tool";
import { getRouterLevel } from '@/vue/util/tool'
export default {
    props: {
        sta: false
    },

    data() {
        let curTime = currentTime();
        let token = sessionStorage.getItem("accessToken") || "";
        return {
            curTime,
            headers: {
                accessToken: token
            },
            departpopshow: false,
            departmentList: [],
            userList: [],
            shiftList: [],
            holidayList: [],
            checkList: [], //审批人列表
            Form: {
                applyId: "2", //
                partmentName: "", //部门
                partmenId: "", //部门id
                applyDemo: "", //备注
                employeeId: "", //申请人编号
                holidayTypeId: "", //请假类型编号
                beginDatetime: "", //请假开始时间
                endDatetime: "", //请假结束时间
                repairCardTime: [], //补卡班次
                holidayNumber: "", //请假时长
                pictureIds: "" //附件url
            },
            defaultProps: {
                children: "child"
            },
            storeId: "",
            time: ""
        };
    },

    mounted() {
        // this.getdepartmentFindAll();
        this.holidayQuery();
    },

    methods: {
        cancel() {
            this.$emit("cancel", false);
        },
        // 获取部门
        getdepartmentFindAll() {
            this.$post(departmentFind).then(res => {
                if (res.success) {
                    this.departmentList = res.data;
                }
            });
        },

        holidayQuery() {
            // 查询请假类型列表
            let params = {
                whetherOpen: "YES"
            };
            this.$post(holidayQuery, params).then(res => {
                if (res.success) {
                    this.holidayList = res.data;
                } else {
                    this.$message.error(res.msg);
                }
            });
        },

        Getmessage(val) {
            //    员工列表/查询员工
            if (val) {
                var params = {
                    permissionLevel: getRouterLevel('申请人'),
                    status:'ENABLE',
                };
                this.$post(employeeQuery, params).then(res => {
                    if (res.success === true) {
                        this.userList = res.data;
                    }
                });
            }
        },

        queryShifts() {
            // 查询补卡班次列表
            if (this.Form.employeeId && this.Form.beginDatetime) {
                let params = {
                    employeeId: this.Form.employeeId,
                    beginDatetime: this.Form.beginDatetime.split(' ')[0],
                    id: this.Form.applyId
                };
                this.$post(queryShifts, params).then(res => {
                    if (res.success) {
                        this.shiftList = res.data;
                    }else{
                        this.$message.error(res.msg)
                    }
                });
            }
        },

        queryCheckEmployee() {
            // 审批人列表
            if (this.Form.employeeId) {
                let params = {
                    employeeId: this.Form.employeeId,
                    id: this.Form.applyId
                };
                console.log(123213213)
                this.$post(queryCheckEmployee, params).then(res => {
                    if (res.success) {
                        this.checkList = [];
                        if (res.data.length != 0) {
                            res.data.map((item, index) => {
                                if (item.names.length != 0) {
                                    item.names.map((ite, idx) => {
                                        this.checkList.push(ite);
                                        if (idx != item.names.length - 1) {
                                            this.checkList.push("-");
                                        }
                                    });
                                    if (index != res.data.length - 1) {
                                        this.checkList.push("+");
                                    }
                                }
                            });
                        }
                    }else{
                        this.$message.error(res.msg)
                        this.$emit("cancel", false);
                    }
                });
            }
        },

        save() {
            console.log(11111,this.Form.repairCardTime)
            if (!this.Form.employeeId) {
                this.$message.error("申请人不能为空");
                return;
            } 
            else if (!this.Form.beginDatetime) {
                this.$message.error("开始时间不能为空");
                return;
            } else if (!this.Form.repairCardTime) {
                this.$message.error("补卡班次不能为空");
                return;
            } else if (!this.Form.applyDemo) {
                this.$message.error("补卡详情不能为空");
                return;
            }
            let params = Object.assign({}, this.Form);
            params.repairCardTime = params.repairCardTime.join('#')
            this.$post(addApplication, params).then(res => {
                if (res.success) {
                    this.$message.success(res.msg);
                    this.$emit("cancel", false);
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleNodeClick(node, data) {
            this.Form.partmentName = node.name;
            this.Form.partmenId = node.id;
            this.departpopshow = false;
        },
        handleAvatarError(err, file, fileList) {},
        handleAvatarSuccess(res, file) {
            if (res.code==200){
                this.Form.pictureIds = res.uri;
            } else {
                this.$message.error(res.msg)
            }
            // this.Form.pictureIds = res.uri;
            //cosole.log(21323,res)
        }
    }
};
</script>



<style lang="less">
.repairCardRequest {
    .el-dialog {
        .el-input__icon {
            line-height: 26px !important;
        }
        .avatar-uploader-icon{
            line-height: 90px !important;
        }
        .el-dialog__header {
            padding: 20px 30px 0 30px;
        }
        .el-dialog__body {
            .leaveRequest_content {
                padding: 20px 30px 0 30px;
                .departpop {
                    width: 170px;
                    position: absolute;
                    left: 0;
                    top: 41px;
                    z-index: 10;
                    border: 1px solid #eee;
                    .tree-item {
                        display: flex;
                        align-items: center;
                        img {
                            padding-right: 10px;
                        }
                    }
                }
                .item {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;
                    &_div {
                        flex: 1;
                        display: flex;
                        align-items: center;
                        padding: 10px 0;
                        .el-checkbox-group {
                            margin: 0;
                        }
                        .label {
                            min-width: 80px;
                            display: inline-block;
                            font-size: 14px;
                            font-family: Microsoft YaHei;
                            font-weight: 400;
                            text-align: right;
                            .notice {
                                color: #ff0000;
                            }
                        }
                        .iconfont1 {
                            color: #90b5ff;
                        }
                        .item_list {
                            display: flex;
                            align-items: center;
                            flex-direction: row;
                            flex-wrap: wrap;
                            & > div {
                                margin-top: 10px;
                            }
                        }
                        .person {
                            display: inline-block;
                            width: 54px;
                            height: 54px;
                            line-height: 54px;
                            margin: 0 2px;
                            text-align: center;
                            background: rgba(144, 181, 255, 1);
                            border-radius: 50%;
                            color: #ffffff;
                        }
                        .el-input {
                            width: 120px;
                            height: 26px;
                            margin-right: 20px;
                            .el-input__inner {
                                padding: 0 10px;
                                height: 26px;
                            }
                        }
                        .el-date-editor {
                            width: 200px;
                            .el-input__inner {
                                width: 200px;
                                padding: 0 30px;
                                height: 26px;
                                line-height: 26px;
                            }
                        }
                    }
                }
            }
            .dialog-foot {
                text-align: right;
                margin-top: 50px;
                background: #f5f5f5;
                padding: 20px;
                .foot-cancel,
                .foot-save {
                    width: 80px;
                    height: 40px;
                    border: none;
                    outline: none;
                    border-radius: 4px;
                    font-size: 16px;
                    color: #ffffff;
                    margin-right: 20px;
                }
                .foot-cancel {
                    background: #cccccc;
                }
                .foot-save {
                    background: #5e75e6;
                }
            }
        }
    }
}
</style>